module.exports = __webpack_public_path__ + "static/media/icici.87753f25.png";